import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import styles from 'components/BackButton/BackButton.scss';

export const BackButton = ({ text, path }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (path) {
      navigate(path);
    } else {
      navigate(-1);
    }
  };

  return (
    <button className={styles.backBtn} onClick={handleClick}>
      <FontAwesomeIcon className={styles.arrow} icon={faArrowLeft} />
      {text}
    </button>
  );
};
